import { useSearchParamState } from "use-search-param-state";
import dayjs from "../dayjs";
import { startOfPreviousMonth } from "../misc/dateUtils";
import { useTagParams } from "../publicPackages2/filter/useTagParams";

const NAME_KEY = "name";
const MONTH_KEY = "month";

export const useECommerceSearch = () => {
  const [rawName] = useSearchParamState(NAME_KEY, "");
  const [monthParam] = useSearchParamState(MONTH_KEY, "");
  const month = monthParam ? dayjs(monthParam, "YYYY-MM") : startOfPreviousMonth();
  const { tags } = useTagParams();

  return {
    searchCriteria: {
      text: rawName,
      month,
      tags,
    },
  };
};
